
/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import { CouponLightboxNew } from '@bingads-webui-react/feature-adoption-coupon';
import { Constants as CCUIConstants } from '@bingads-webui-clientcenter/entity-utils';

import {
  APPLY_ACTION_TYPES,
  CHANNEL_TYPES,
  SUMMARY_CARD,
  SUMMARY_APPLY_ALL_ENABLED,
  ADINSIGHT_LOG_ACTION_TYPE,
  RECOMMENDATION_TYPES,
  dismissFeedback,
  isShowAutoApplyFeedback,
  getChannel,
} from '@bingads-webui-campaign/recommendation-core';

import { showDismissFeedbackPopup } from '@bingads-webui-campaign-react/recommendation-dismiss-feedback';
import { showApplyFeedbackPopup } from '@bingads-webui-campaign-react/recommendation-feedback-modal';
import { handleRecommendationNotification } from '@bingads-webui-campaign/recommendation-notification';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';

const FAC_STATUS_NOT_IN_PROGRESS = CCUIConstants.RecommendationAdoptionStatus.NotInProgess;

export class SummaryFooter extends React.PureComponent {
  static propTypes = {
    summary: PropTypes.shape({
      coupon: PropTypes.object,
    }).isRequired,
    viewRecommendations: PropTypes.string.isRequired,
    apply: PropTypes.string.isRequired,
    viewDetails: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    track: PropTypes.func,
    recommendationsCount: PropTypes.number.isRequired,
    opportunityCount: PropTypes.number,
    campaignAdGroups: PropTypes.arrayOf(PropTypes.object),
    level: PropTypes.string,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    logOpportunityEvent: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    currentActivity: PropTypes.objectOf(PropTypes.any).isRequired,
    context: PropTypes.shape({
      Source: PropTypes.string,
      Level: PropTypes.string.isRequired,
      Category: PropTypes.string,
    }),
    guid: PropTypes.string,
    logExpInfo: PropTypes.func,
    scope: PropTypes.shape({
      campaignId: PropTypes.number,
      customerId: PropTypes.number,
      accountId: PropTypes.number,
    }),
    odata: PropTypes.PropTypes.shape({
      get: PropTypes.func.isRequired,
    }),
    preferencesService: PropTypes.objectOf(PropTypes.any),
    isInlineView: PropTypes.bool,
    appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
    dataService: PropTypes.objectOf(PropTypes.any),
    showAsyncApplyModal: PropTypes.func,
    closeAsyncApplyModal: PropTypes.func,
    showApplyConfirmModal: PropTypes.func,
    isMCC: PropTypes.bool,
    optimizationScore: PropTypes.number,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    category: PropTypes.string,
    isOverviewPage: PropTypes.bool,
    isOptimizationScoreOn: PropTypes.bool,
    inContextCard: PropTypes.bool,
    permissions: PropTypes.shape({}),
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }),
  };

  static defaultProps = {
    campaignAdGroups: [],
    level: null,
    logExpInfo: _.noop,
    guid: null,
    scope: null,
    odata: null,
    context: undefined,
    dataService: undefined,
    readOnly: undefined,
    track: _.noop,
    preferencesService: null,
    isInlineView: false,
    showAsyncApplyModal: _.noop,
    closeAsyncApplyModal: _.noop,
    showApplyConfirmModal: null,
    isMCC: false,
    opportunityCount: 0,
    optimizationScore: null,
    overallOptimizationScoreBar: null,
    category: null,
    isOverviewPage: false,
    isOptimizationScoreOn: false,
    inContextCard: false,
    permissions: {},
    newI18n: {
      getString: _.noop,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      showLightbox: false,
      lightboxAction: _.null,
    };
  }

  autoApplyDialogInSummary = () => {
    const {
      campaignAdGroups,
      context,
      currentActivity,
      guid,
      preferencesService,
      i18n,
      odata,
      scope,
      type,
      recommendationsCount,
      showApplyConfirmModal,
      permissions,
      newI18n,
      dataService,
    } = this.props;
    const options = {
      i18n,
      el: '.recommendation-apply-feedback-popup',
      data: {
        type,
        channel: CHANNEL_TYPES.RECOMMENDATION,
        campaignAdGroups,
      },
      guid,
      context,
      callback: () => {
        this.applyAll();
      },
      cid: scope.advertiserCustomerId,
      aid: scope.accountId,
      odata,
      isFromSummary: true,
      isFromAutoApplyDialog: true,
      recommendationsCount,
      onAutoApplyCancel: () => {
        showDismissFeedbackPopup({
          i18n,
          type,
          onSubmit: (feedback) => {
            dismissFeedback({
              campaignId: scope.campaignId,
              currentActivity,
              feedback,
              preferencesService,
              rejectAutoApplySuggestedAds: true,
              context,
              guid,
              isMCC: this.props.isMCC,
            });
          },
          rejectAutoApplySuggestedAds: true,
        });
      },
      showApplyConfirmModal: () => showApplyConfirmModal({
        onApply: this.applyAll,
        countRecommendation: recommendationsCount,
      }),
      permissions,
      newI18n,
      dataService,
    };
    showApplyFeedbackPopup(options);
  };

  confirmApplyAll = () => {
    const { preferencesService, type, permissions } = this.props;
    const rejectAutoApplySuggestedAds = true;
    // Conditions:
    // 1. not in customer level
    // 2. Apply all new ads recommendations in summary page
    // 3. Users don't reject auto-apply confirmation dialog within 30 days.
    // Result: Show a dialog to confirm enabling auto-apply ad suggestions.
    if (!this.props.isMCC
      && (permissions.IsRSAAutoApplyEnabled && type === RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS)
      && isShowAutoApplyFeedback({ preferencesService, type, rejectAutoApplySuggestedAds })) {
      this.autoApplyDialogInSummary();
      return;
    }

    if (_.isFunction(this.props.showApplyConfirmModal)) {
      this.props.showApplyConfirmModal({
        onApply: this.applyAll,
        countRecommendation: this.props.recommendationsCount,
        type,
      });
    } else {
      // eslint-disable-next-line no-alert, no-restricted-globals
      if (!confirm(this.props.i18n.getString('Recommendation_Apply_All_Confirm', {
        count: this.props.recommendationsCount,
      }))) {
        return;
      }
      this.applyAll();
    }
  };

  applyAll = () => {
    const {
      campaignAdGroups,
      type,
      optimizationScore,
      isOptimizationScoreOn,
      isMCC,
      inContextCard,
      isInlineView,
      isOverviewPage,
    } = this.props;

    const action = `${this.props.recommendationsCount} recommendations applied`;
    this.props.logExpInfo(action);

    const channel = getChannel(type, isInlineView, isMCC, isOverviewPage, inContextCard);


    this.props.currentActivity.trace(
      `recommendation summary view: apply all is called, channel = ${channel}, type = ${type}`,
      `${channel}/applyall`
    );

    const contextWithTrackingId = _.extend({}, this.props.context, { trackId: generateGuid() });
    this.props.logOpportunityEvent({
      type: this.props.type,
      action: ADINSIGHT_LOG_ACTION_TYPE.CLICK_APPLYALL,
      context: contextWithTrackingId,
    });

    // now applyMode in context align with which mt api called, may need to modify in the future
    const contextWithApplyMode = _.extend({}, contextWithTrackingId, { ApplyMode: 'All' });

    this.props.track({
      type,
      userAction: APPLY_ACTION_TYPES.ACCEPT,
      campaignAdGroups,
      channel,
      applyOpportunitiesLevel: this.props.level,
      context: contextWithApplyMode,
      guid: this.props.guid,
      handleRecommendationNotification,
      viewDetails: this.props.viewDetails,
      from: SUMMARY_CARD,
      showAsyncApplyModal: this.props.showAsyncApplyModal,
      closeAsyncApplyModal: this.props.closeAsyncApplyModal,
      // because opportunity is the base unit MT applied
      totalRecommendationCount: this.props.opportunityCount,
      isOptimizationScoreUsed: isOptimizationScoreOn,
      optimizationScore,
    });
  };

  viewAll = () => {
    const channel = getChannel(
      this.props.type,
      this.props.isInlineView,
      this.props.isMCC,
      this.props.isOverviewPage,
      this.props.inContextCard
    );

    this.props.currentActivity.trace(
      `recommendation summary view: view all is called, channel = ${channel}, type = ${this.props.type}`,
      `${channel}/viewAll`
    );

    this.props.logOpportunityEvent({
      type: this.props.type,
      action: ADINSIGHT_LOG_ACTION_TYPE.CLICK_RECS,
      context: _.extend({}, this.props.context, { RecommendationCount: this.props.opportunityCount }),
    });

    if (channel !== CHANNEL_TYPES.INCONTEXT &&
      channel !== CHANNEL_TYPES.INCONTEXTCARD &&
      channel !== CHANNEL_TYPES.OVERVIEWPAGE &&
      channel !== CHANNEL_TYPES.MCCOVERVIEW) {
      this.props.appConfig.set('recsrc', 'summarypage');
    }
    this.props.viewDetails(this.props.type, this.props.category)();
  };

  buttonActionWithCoupon = (action) => {
    if (
      this.props.summary.coupon
      && !this.props.inContextCard
      && this.props.summary.coupon.rawData.Status === FAC_STATUS_NOT_IN_PROGRESS) {
      this.setState({
        showLightbox: true,
        lightboxAction: action,
      });
    } else {
      action();
    }
  };

  viewAllButtonAction = () => this.buttonActionWithCoupon(this.viewAll);

  applyAllButtonAction = () => this.buttonActionWithCoupon(this.confirmApplyAll);

  hideLightbox = () => {
    this.setState({ showLightbox: false });
  };

  lightboxAction = () => {
    const action = this.state.lightboxAction;
    this.setState({
      showLightbox: false,
      lightboxAction: _.null,
    });
    this.props
      .dataService
      .startCouponAdoption(this.props.summary.coupon.rawData)
      .finally(action);
  };

  render() {
    return (
      <div className="recommendation-summary-footer">
        <div className="summary-action-buttons">
          <button type="button" className={classNames('btn-primary', 'btn')} onClick={this.viewAllButtonAction}>{this.props.viewRecommendations}</button>
          {SUMMARY_APPLY_ALL_ENABLED[this.props.type] &&
          <button type="button" disabled={this.props.readOnly} className={classNames('btn-default', 'btn')} onClick={this.applyAllButtonAction}>{this.props.apply}</button>
          }
        </div>
        { this.props.summary.coupon
          && !this.props.inContextCard
          && this.state.showLightbox
          && this.props.dataService
          && (
          <CouponLightboxNew
            coupon={this.props.summary.coupon}
            i18n={this.props.i18n}
            onSubmit={this.lightboxAction}
            onCancel={this.hideLightbox}
          />
        )}
      </div>
    );
  }
}
